import type { RecordersClips, VideoType } from './types';
import { useVideoStore } from './useScreenRecordersPersistence';

export const useRecorderClips = (
  userId?: string,
  workspaceId?: string,
): RecordersClips => {
  const { getVideos, addVideo, removeVideo } = useVideoStore((state) => ({
    getVideos: state.getVideos,
    addVideo: state.addVideo,
    removeVideo: state.removeVideo,
  }));

  const videos = userId && workspaceId ? getVideos(workspaceId, userId) : [];

  return {
    videos,
    addVideo: (video: VideoType) => {
      if (!userId || !workspaceId) {
        console.warn('No userId or workspaceId provided, cannot add video.');
        return;
      }
      addVideo(workspaceId, userId, video);
    },
    removeVideo: (videoDate: string) => {
      if (!userId || !workspaceId) {
        console.warn('No userId or workspaceId provided, cannot add video.');
        return;
      }
      removeVideo(workspaceId, userId, videoDate);
    },
  };
};
